import { InfoCircledIcon } from '@radix-ui/react-icons'
import { type AppEnv } from '#app/utils/env.server.ts'

export function EnvironmentBanner({ appEnv }: { appEnv: AppEnv }) {
  if (appEnv !== 'labs') {
    return null
  }

  return (
    <div
      role="status"
      className="flex w-full items-center justify-center gap-2 bg-amber-50 px-4 py-1.5 text-center text-sm text-amber-800 dark:bg-amber-950 dark:text-amber-200"
    >
      <InfoCircledIcon className="h-4 w-4 shrink-0" />
      <span>Welcome to DEx Labs — a space to explore and experiment.</span>
    </div>
  )
}
